import { render, staticRenderFns } from "./MessagingDetails.vue?vue&type=template&id=4d910ec5"
import script from "./MessagingDetails.vue?vue&type=script&lang=js"
export * from "./MessagingDetails.vue?vue&type=script&lang=js"
import style0 from "./MessagingDetails.vue?vue&type=style&index=0&id=4d910ec5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports